<template>
  <v-dialog persistent v-model="editMode" :width="type === 'stadium' ? 700 : 400">
    <v-card title="Dialog">
      <div class="card-container">
        <v-card-title style="font-size:1.6em">
          {{ title }}
        </v-card-title>
        <div v-if="type === 'stadium'" style="display: flex;">
          <v-combobox class="stadium-selector" label="Seleccionar estadio" v-model="selectedStadium"
          :items="estadios" item-text="description" item-value="id" persistent-hint return-object></v-combobox>
          <v-btn v-on="on" flat fab icon>
            <v-icon color="green" @click="newEstadio">add</v-icon>
          </v-btn>
          <InformeAuditoriaCreateEstadioPopUp
              :reserva="reserva"
              @estadioCreado="handleEstadioCreado"
              :width="'500'"
              ref="creacionEstadioPopup">
          </InformeAuditoriaCreateEstadioPopUp>
        </div>
        <div v-else-if="type === 'directores'" style="padding: 10px 20px;">
          <v-autocomplete
            v-model="selectedDirectores"
            :items="directores"
            item-text="nombreCompleto"
            item-value="id"
            label="Seleccionar directores"
            multiple
            chips
            deletable-chips
            return-object
          ></v-autocomplete>
        </div>
        <div v-else-if="type === 'participantes'" style="padding: 10px 20px;">
          <v-autocomplete
            v-model="selectedParticipantesLpf"
            :items="participantesLpf"
            item-text="nombreCompleto"
            item-value="id"
            label="Seleccionar participantes LPF"
            multiple
            chips
            deletable-chips
            return-object
          >
            <template slot="item" slot-scope="{ item }">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.nombreCompleto }}</v-list-tile-title>
                <v-list-tile-sub-title class="grey--text">
                  {{ item.username }} - {{ item.departamento ? item.departamento : 'Sin departamento' }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </div>
        <div class="contenedor-datetime" v-else>
          <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="selectedDate" label="Seleccionar día" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker locale="es-ar" v-model="selectedDate" @input="menu1 = false"></v-date-picker>
          </v-menu>
          <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time"
            transition="scale-transition" offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="selectedTime" label="Seleccionar horario" prepend-icon="mdi-clock-outline"
                readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-time-picker v-if="menu2" value="30" v-model="selectedTime" full-width
              @click:minute="$refs.menu.save(time)"></v-time-picker>
          </v-menu>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text="Close Dialog" @click="cancel" :disabled="isSubmitting">Cancelar</v-btn>
          <v-btn @click="submit" color="info" :loading="isSubmitting" :disabled="isSubmitting">Guardar</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import InformeAuditoriaCreateEstadioPopUp from '../../informes-auditorias/components/fields_components/InformeAuditoriaCreateEstadioPopUpPartido'
export default {

  data () {
    return {
      selectedStadium: null,
      selectedDate: null,
      selectedTime: null,
      estadios: null,
      menu1: false,
      menu2: false,
      exitTimeField: false,
      reserva: Boolean,
      fetchPath: 'informe-auditoria/estadios',
      directores: [],
      selectedDirectores: [],
      participantesLpf: [],
      selectedParticipantesLpf: [],
      isSubmitting: false
    }
  },
  components: {
    InformeAuditoriaCreateEstadioPopUp
  },
  props: {
    editMode: null,
    title: null,
    type: null,
    date: null,
    time: null,
    partidoId: null,
    categoria: null,
    directoresAsignados: {
      type: Array,
      default: () => []
    },
    participantesLpfAsignados: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    this.dateTimeDefaultValues()
  },
  methods: {
    fetchEstadios () {
      this.axios
        .get(`informe-auditoria/estadios?order=asc&reserva=${this.categoria === 'Primera' ? 'false' : 'true'}`)
        .then(response => {
          this.estadios = response.data.map(e => e)
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchDirectores () {
      this.axios
        .get(`informe-auditoria/directores`)
        .then(response => {
          this.directores = response.data.filter(director => director.id !== 15)
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchParticipantesLpf () {
      this.axios
        .get(`informe-auditoria/participantes-lpf`)
        .then(response => {
          this.participantesLpf = response.data
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    updateParticipantesDelChat () {
      this.isSubmitting = true
      const directoresIds = this.selectedDirectores.map(d => d.usuario)
      const participantesIds = this.selectedParticipantesLpf.map(p => p.id)

      this.axios
        .post(`informe-auditoria/chats/partidos/${this.partidoId}/asignar-usuarios/`, {
          'usuariosIds': [...directoresIds, ...participantesIds]
        })
        .then(() => {
          this.$router.go()
        })
        .catch(error => {
          this.isSubmitting = false
          this.$store.commit('setErrorMsg', error)
        })
    },
    updateEstadio () {
      this.isSubmitting = true
      this.axios
        .patch(`informe-auditoria/partido/${this.partidoId}`, {
          'stadium': this.selectedStadium.id
        })
        .then(() => {
          this.$router.go()
        })
        .catch(error => {
          this.isSubmitting = false
          this.$store.commit('setErrorMsg', error)
        })
    },
    updateDateTime () {
      this.isSubmitting = true
      this.axios
        .patch(`informe-auditoria/partido/${this.partidoId}`, {
          'dateRealization': `${this.selectedDate} ${this.selectedTime}`
        })
        .then(() => {
          this.$router.go()
        })
        .catch(error => {
          this.isSubmitting = false
          this.$store.commit('setErrorMsg', error)
        })
    },
    submit () {
      if (this.type === 'stadium') {
        this.updateEstadio()
      }
      if (this.type === 'datetime') {
        this.updateDateTime()
      }
      if (this.type === 'directores') {
        this.updateParticipantesDelChat()
      }
      if (this.type === 'participantes') {
        this.updateParticipantesDelChat()
      }
    },
    cancel () {
      this.isSubmitting = false
      this.$emit('cancelEditMode')
    },
    dateTimeDefaultValues () {
      this.selectedDate = this.date
      this.selectedTime = this.time
    },
    newEstadio () {
      this.$refs.creacionEstadioPopup.showDialog()
    },
    handleEstadioCreado (responseEvent) {
      this.data = responseEvent.data
      this.fetchEstadios()
      this.selectedStadium = this.data
      // this.$emit('updateField', this.field)
    }
  },
  created () {
    this.fetchEstadios()
    this.reserva = this.categoria !== 'Primera'
    if (this.type === 'directores') {
      this.fetchDirectores()
      this.selectedDirectores = this.directoresAsignados
      this.selectedParticipantesLpf = this.participantesLpfAsignados
    }
    if (this.type === 'participantes') {
      this.fetchParticipantesLpf()
      this.selectedParticipantesLpf = this.participantesLpfAsignados
      this.selectedDirectores = this.directoresAsignados
    }
  }

}
</script>

<style scoped>
.card-title {
  font-size: 1.8em;
  padding-left: 20px;
  padding-top: 4% !important;
}

.stadium-selector {
  padding-top: 3%;
  padding-left: 5%;
  padding-right: 5%;

}

.v-card-title {
  font-size: 30px;
}

.contenedor-datetime {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
